module.exports = __webpack_public_path__ + "img/yukari yakumo_sc2.9135f9af.png";